import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';

const Recommendations = ({ recommendations }) => {
  // Afficher uniquement le bilan (nouveau système)
  const bilanContent = recommendations?.bilan || '';

  // Si pas de bilan, ne rien afficher
  if (!bilanContent) {
    return null;
  }

  return (
    <Box sx={{ px: 0, mt: 2 }}>
      <Card
        sx={{
          border: '1px solid #DDD',
          boxShadow: 'none',
          p: 2,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AssessmentIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Bilan de la semaine</Typography>
          </Box>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {bilanContent}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Recommendations;
